<template>
  <!-- Multi-select routes through BaseFilterSelect, the app's proven multi
       picker (handles chip removal correctly — fixes the "can't remove the
       rest" bug). Single-select keeps the original plain look. -->
  <base-filter-select
      v-if="isMultiple"
      v-model="model"
      :options="groupedOptions"
      label="name"
      :reduce="(org) => org.id"
      multiple
      :clearable="clearable"
      :select-props="mergedSelectProps"
      :placeholder="placeholder"
  >
    <template #option="org">
      <div v-if="org._isGroup" class="desk-opt-header">{{ org.name }}</div>
      <span v-else>{{ org.name }}</span>
    </template>
    <template v-if="acronym != null && acronym !== false" #selected-option="org">
      <div class="text-center">
        <b-avatar size="25" class="d-inline-block" v-b-tooltip :title="org.name">{{ initialName(org.name) }}</b-avatar>
      </div>
    </template>
  </base-filter-select>

  <v-select
      v-else
      v-model="model"
      :options="groupedOptions"
      label="name"
      :reduce="(org) => org.id"
      v-bind="selectProps"
      :clearable="clearable"
      v-bind:readonly="readonly"
      v-bind:disabled="disabled"
      :selectable="opt => !(opt && opt._isGroup)"
      :placeholder="placeholder"
  >
    <template #option="org">
      <div v-if="org._isGroup" class="desk-opt-header">{{ org.name }}</div>
      <span v-else>{{ org.name }}</span>
    </template>
    <template #selected-option="org">
      <div class="text-center" v-if="acronym != null && acronym !== false">
        <b-avatar size="25" class="d-inline-block" v-b-tooltip :title="org.name">{{ initialName(org.name) }}</b-avatar>
      </div>
      <span v-else>{{ org.name }}</span>
    </template>
  </v-select>
</template>

<script>
import { initialName, groupItemsByDesk } from '@/model/Utils'
import BaseFilterSelect from '@/components/widget/select/BaseFilterSelect.vue'

export default {
  name: 'OrganizationSelectBox',
  components: { BaseFilterSelect },
  props: {
    value: {
      required: true,
    },
    acronym: {
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    clearable: {},
    selectProps: {
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    placeholder: {
      type: String,
      default: () => ''
    }
  },
  watch: {
    value(){
      this.setDefaultOrg()
    }
  },
  created() {
    this.setDefaultOrg()
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    isMultiple(){
      return this.multiple || this.selectProps?.multiple
    },
    // Organizations grouped under their desk (header rows are non-selectable).
    groupedOptions(){
      const orgs = this.$store.getters['data/allOrganizations'] || []
      return groupItemsByDesk(orgs, o => o.desk, o => o.name)
    },
    // BaseFilterSelect forwards selectProps onto the underlying vue-select, so
    // disabled/readonly/selectable are passed through here rather than as top-level props.
    mergedSelectProps(){
      return {
        ...this.selectProps,
        disabled: this.disabled || this.selectProps?.disabled === true,
        readonly: this.readonly || this.selectProps?.readonly === true,
        selectable: opt => !(opt && opt._isGroup),
      }
    }
  },
  methods: {
    initialName,
    setDefaultOrg(){
      if(!this.isMultiple && this.value != null){
        return
      }
      if(this.isMultiple && Array.isArray(this.value) && this.value.length > 0){
        return
      }
      let orgs = this.$store.getters['data/allOrganizations'];
      if(orgs.length === 0 || orgs.length > 1){
        return
      }
      if (this.multiple || this.selectProps?.multiple) {
        this.model = [orgs[0].id]
      } else {
        this.model = orgs[0].id
      }
    }
  }
}
</script>

<style scoped>

</style>
